const topics = [
  { name: '热血冒险', count: '3.2万', hot: true },
  { name: '恋爱校园', count: '2.8万', hot: true },
  { name: '玄幻修仙', count: '4.1万', hot: true },
  { name: '悬疑推理', count: '1.6万', hot: false },
  { name: '科幻未来', count: '1.2万', hot: false },
  { name: '搞笑日常', count: '2.3万', hot: true },
  { name: '古风言情', count: '1.9万', hot: false },
  { name: '异能都市', count: '2.5万', hot: true },
  { name: '灵异恐怖', count: '0.9万', hot: false },
  { name: '运动竞技', count: '0.7万', hot: false },
  { name: '美食治愈', count: '1.1万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-600">探索51漫画在线最受欢迎的漫画类型与讨论</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href="#index"
              onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
              className={`group flex items-center gap-2 px-5 py-3 rounded-xl cursor-pointer no-underline transition-all ${
                topic.hot
                  ? 'bg-accent-100/80 text-accent-800 hover:bg-accent-200'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              <span className="text-sm font-medium">{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-accent-600' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
              {topic.hot && (
                <span className="flex items-center gap-0.5 text-xs text-primary-500">
                  <i className="ri-fire-line"></i>
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}